import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Live countdown — guest signup deadlines (P1-09), auction close, settlement timers.
export default class extends Controller {
  static values = {
    deadline: String,
    prefix: { type: String, default: "" },
    suffix: { type: String, default: "left to sign up" },
    expired: { type: String, default: "expired" },
    refreshOnExpire: { type: Boolean, default: false },
  }

  connect() {
    this.refreshed = false
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    const deadline = Date.parse(this.deadlineValue)
    if (Number.isNaN(deadline)) return

    const remaining = Math.max(0, deadline - Date.now())
    const totalSeconds = Math.floor(remaining / 1000)

    if (remaining === 0) {
      this.element.textContent = this.expiredValue
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.refreshIfNeeded()
      return
    }

    const formatted = this.formatRemaining(totalSeconds)
    const suffix = this.suffixValue.trim()
    this.element.textContent = suffix
      ? `${this.prefixValue}${formatted} ${suffix}`
      : `${this.prefixValue}${formatted}`.trim()
  }

  refreshIfNeeded() {
    if (!this.refreshOnExpireValue || this.refreshed) return

    this.refreshed = true
    Turbo.visit(window.location.href, { action: "replace" })
  }

  formatRemaining(totalSeconds) {
    if (totalSeconds >= 86_400) {
      const days = Math.floor(totalSeconds / 86_400)
      const hours = Math.floor((totalSeconds % 86_400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      return `${days}d ${hours}h ${minutes}m`
    }

    if (totalSeconds >= 3600) {
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      return `${hours}h ${minutes}m`
    }

    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${String(seconds).padStart(2, "0")}`
  }
}
